<template>
  <div class="form-bg">
    <div class="f-title">{{ tableDatas.bTitle }}</div>
    <div class="table-d">
      <div class="table-d-t" v-for="(tableCells, index) in tableDatas.b" :key="index">
        <div v-for="(cell, index2) in tableCells.data" :key="index2">
          <div><input :title="cell" :value="cell" readonly /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgDatas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableDatas: [],
      tableCellFlex: [],
      // propData: [],
    }
  },
  mounted() {
    // this.propData = this.bgDatas
    this.initABData()
  },
  methods: {
    initABData() {
      const aData = {}
      let bData = {}
      const bList = []
      for (const index in this.bgDatas) {
        if (this.bgDatas[index]['a'] !== undefined) {
          bData = {}
          const a = this.bgDatas[index]['a']
          aData['bTitle'] = a.t3
          bData['isTitle'] = true
          const t = []
          t.push('编码')
          t.push('名称')
          t.push('税号')
          t.push('地址、电话')
          t.push('开户行及账号')
          t.push('简码')
          t.push('邮箱')
          t.push('备注')
          bData['data'] = t
          this.tableCellFlex = a.t5.split(';')
          bList.push(bData)
        } else if (this.bgDatas[index]['b'] !== undefined) {
          const bl = this.bgDatas[index]['b']
          for (const jIndex in bl) {
            const b = bl[jIndex]
            bData = {}
            const t = []
            t.push(b.b21)
            t.push(b.b22)
            t.push(b.b23)
            t.push(b.b24)
            t.push(b.b25)
            t.push(b.b26)
            t.push(b.b27)
            t.push(b.b28)
            bData['data'] = t
            bData['isTitle'] = false
            bList.push(bData)
          }
        }
      }
      aData['b'] = bList
      this.tableDatas = aData
    },
  },
  destroyed() {
    console.log('destroy')
  },
}
</script>

<style lang="less" scoped>
.form-bg {
  //   background: url('../../../../assets/images/qtbd_tyjsb_9h10l.jpg');
  padding: 30px;
  padding-bottom: 0;
  width: 1200px;
  height: 300px;
}
.f-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  line-height: 30px !important;
}
.table-d {
  margin-top: 30px;
}
.table-d-t {
  display: -webkit-flex;
  display: flex;
}
.table-d-t > div,
input {
  flex: 1;
  border: 1px solid #000;
  margin-top: -1px;
  margin-right: -1px;
  padding-right: 5px;
  font-family: '楷体_GB2312', '楷体';
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0px;
  word-spacing: normal;
  overflow: hidden;
  line-height: 18px;
  height: 20px;
  text-align: center;
}
input {
  font-family: '楷体_GB2312', '楷体';
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  background: none;
  letter-spacing: 0px;
  word-spacing: normal;
  border: 1px none #cccccc;
  overflow: hidden;
  width: 100%;
  line-height: 18px;
}
</style>
